enum AccessReportsWizardGroupPropertyIdEnum {
  AccessListingPages = "accessListingPages",
  AccessOverviewPages = "accessOverviewPages",
  AccessRadiusSearch = "accessRadiusSearchPages",
  AccessReportsWizardSummaryPages = "accessReportsWizardSummaryPages",
  AccessReportsWizardDetailsPages = "accessReportsWizardDetailsPages",
  AccessReportsWizardEmployeeCountPage = "employeeCountPages",
  AccessReportsWizardProviderCountPages = "providerCountPages",
}

export { AccessReportsWizardGroupPropertyIdEnum };
